import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { FormMode, Languages, ServiceStatus, RefundMeasFirstReviewerDecision,TransitRequestWFSteps } from 'src/app/shared/models/enums.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { first } from 'rxjs/operators';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';

@Component({
  selector: 'app-marine-officer-review',
  templateUrl: './marine-officer-review.component.html'
})
export class MarineOfficerReviewComponent implements OnInit {

  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  displayedLang: string;
  submitted = false;
  baseRequestId: string = '';
  user: User = new User();
  stepHistoryId: any;
  decisionValue: number;
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  requestStatus: number;
  loading = false;
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestDTO: BaseRequest;
  decision = RefundMeasFirstReviewerDecision;
  decisionKeys = Object.keys(this.decision);
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  marineOfficeReviewerForm: FormGroup;
  stepData: any;
  responseObj: ResponseObject = new ResponseObject();
  requestStatuses: number[] = [];
  stepId: number = TransitRequestWFSteps.TransitDateApproval;

  constructor(private formBuilder: FormBuilder, private transitService: TransitService, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private wfhistoryService: WFHistoryService,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.getBaseRequest();
    }
    else {
      window.history.back();
    }
    //this.getBaseRequest();
    this.user = this.globalSrv.user;
    // this.baseRequestId = '7ba0a817-197c-430a-a4e9-000021631184';

  }

  ngOnInit() {

    this.buildForm(1);


  }

  buildForm(decision) {
    this.marineOfficeReviewerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RefundMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
      this.marineOfficeReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        TransitDate: [{ value: '', disabled: true }, [Validators.required]],
      });
    }
    else if (decision == RefundMeasFirstReviewerDecision.MeasFirstReviewer_MoreInformation) {
      this.marineOfficeReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
    // this.marineOfficeReviewerForm.get('TransitDate').disable();
  }
  changeDecision(value) {
    this.buildForm(value);
    this.marineOfficeReviewerForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
    if (value == RefundMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
      this.marineOfficeReviewerForm.patchValue({
        TransitDate: new Date(this.responseObj.Data['AgentTransitDate']),
      });
    }
  }
  /*receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    if (this.baseRequestId && this.FeesEstimateObj) {
      this.marineOfficeReviewerForm.patchValue({
        TransitDate: new Date(this.responseObj.Data['AgentTransitDate']),
      });
    }
  }*/
  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.getTransitRequest();
        if (this.requestStatuses.includes(ServiceStatus.PendingOnTransitDates)) {
          this.formMode = FormMode.Add;

        }
        else if (this.requestStatuses.includes(ServiceStatus.Transit_PendingTransitApproval_DatePostponed)) {

          this.formMode = FormMode.Add;

        }
        else if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) {

          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();
        }
        else {
          this.getTransitRequestWFHistory();
          this.formMode = FormMode.Readonly;
        }

      }
    )
  }
  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }
  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.TransitDateApproval).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }
    getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;


    this.marineOfficeReviewerForm.patchValue({
      Decision: this.decisionValue
    });

    if (this.decisionValue == RefundMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
      this.marineOfficeReviewerForm.patchValue({
        TransitDate:this.stepData.TransitDate ,
      });
    }
    else if(this.decisionValue == RefundMeasFirstReviewerDecision.MeasFirstReviewer_MoreInformation){
      this.marineOfficeReviewerForm = this.formBuilder.group({
        MoreInformation: this.stepData.MoreInformation,
      });
    }


    this.marineOfficeReviewerForm.disable();
  }
  onSubmit() {
    this.submitted = true;
    if (this.marineOfficeReviewerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.marineOfficeReviewerForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.user.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.user.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;



    this.transitService.SubmitMarineOfficerRevewDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }
        });
  }
  public getTransitRequest() {
    this.transitService.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          //this.formMode = FormMode.Readonly;
          //this.accurateDataForm.patchValue(resObj.Data);

          this.marineOfficeReviewerForm.patchValue({
            TransitDate: new Date(this.responseObj.Data['AgentTransitDate']),
          });


        }
      });
  }
  get form() {
    return this.marineOfficeReviewerForm.controls;
  }
}
